import { Link, useParams } from "react-router-dom";
import { FiRefreshCw, FiMessageSquare, FiPackage } from "react-icons/fi";
import Nav from "../../components/home/Nav";
import AccountList from "../../components/home/AccountList";
import Spinner from "../../components/Spinner";
import Pagination from "../../components/Pagination";
import { useGetReturnRequestsQuery } from "../../store/services/userOrdersService";
import { toman, toPersianNumber } from "../../utils/persian";
import { orderDetailUrl } from "../../utils/orderUrl";

const statusLabels = {
  pending: "در انتظار بررسی",
  reviewing: "در حال بررسی",
  approved: "تأیید شده",
  rejected: "رد شده",
  cancelled: "لغو شده",
};

const formatDate = (value) => {
  if (!value) return "-";

  try {
    return new Date(value).toLocaleDateString("fa-IR");
  } catch {
    return "-";
  }
};

const UserReturns = () => {
  const { page: pageParam } = useParams();
  const page = Number(pageParam) > 0 ? Number(pageParam) : 1;

  const { data, isLoading, isFetching, isError } = useGetReturnRequestsQuery(page);
  const pagination = data?.return_requests;
  const requests = pagination?.data || [];

  return (
    <>
      <Nav />

      <main className="account-page">
        <div className="my-container">
          <div className="account-shell">
            <AccountList />

            <section className="account-content">
              <div className="account-hero account-hero-compact">
                <div>
                  <span className="account-kicker">مرجوعی</span>
                  <h1>درخواست‌های مرجوعی</h1>
                  <p>وضعیت بررسی، پیام ادمین و آیتم‌های مرجوعی سفارش‌های شما</p>
                </div>

                <Link to="/orders" className="account-hero-action">
                  سفارش‌ها
                </Link>
              </div>

              <section className="account-card">
                {isLoading || isFetching ? (
                  <Spinner />
                ) : isError ? (
                  <div className="account-alert">خطا در دریافت درخواست‌های مرجوعی.</div>
                ) : requests.length > 0 ? (
                  <>
                    <div className="account-return-list-page">
                      {requests.map((request) => (
                        <article className={`account-return-page-card is-${request.status}`} key={request.id}>
                          <div className="account-return-page-head">
                            <div>
                              <span>شماره سفارش</span>
                              <strong>{request.order?.order_number || "-"}</strong>
                            </div>

                            <em>{statusLabels[request.status] || request.status || "-"}</em>
                          </div>

                          <div className="account-return-page-meta">
                            <div>
                              <span>تاریخ ثبت</span>
                              <strong>{formatDate(request.created_at)}</strong>
                            </div>

                            <div>
                              <span>مبلغ سفارش</span>
                              <strong>{toman(request.order?.total || 0)}</strong>
                            </div>

                            <div>
                              <span>دلیل</span>
                              <strong>{request.reason || "-"}</strong>
                            </div>
                          </div>

                          {request.description && (
                            <p className="account-return-page-description">{request.description}</p>
                          )}

                          {(request.items || []).length > 0 && (
                            <div className="account-return-page-items">
                              {(request.items || []).map((item) => (
                                <div key={item.id}>
                                  <FiPackage size={17} />
                                  <span>{item.order_item?.product_name || "-"}</span>
                                  <strong>{toPersianNumber(item.quantity || 0)} عدد</strong>
                                </div>
                              ))}
                            </div>
                          )}

                          {request.admin_response && (
                            <div className="account-return-admin-message">
                              <FiMessageSquare size={18} />
                              <div>
                                <span>پیام پشتیبانی</span>
                                <strong>{request.admin_response}</strong>
                              </div>
                            </div>
                          )}

                          <div className="account-return-page-actions">
                            <Link to={orderDetailUrl(request.order)}>
                              مشاهده سفارش
                            </Link>
                          </div>
                        </article>
                      ))}
                    </div>

                    {pagination?.last_page > 1 && (
                      <div className="account-pagination">
                        <Pagination
                          page={page}
                          perPage={pagination.per_page}
                          count={pagination.total}
                          path="user/returns"
                          theme="light"
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="account-empty-state">
                    <FiRefreshCw size={42} />
                    <strong>درخواست مرجوعی ندارید</strong>
                    <p>بعد از ثبت درخواست مرجوعی، وضعیت بررسی و پیام پشتیبانی اینجا نمایش داده می‌شود.</p>
                    <Link to="/orders">مشاهده سفارش‌ها</Link>
                  </div>
                )}
              </section>
            </section>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserReturns;
